export default __webpack_public_path__ + "static/media/5-red-heart_2764-fe0f.32c3c867.png";